import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  animations: [
    trigger('floatAnimation', [
      state(
        'void',
        style({
          transform: 'translateY(0)',
        }),
      ),
      transition(':enter', [
        animate(
          '2s ease-in-out',
          keyframes([
            style({ transform: 'translateY(0)', offset: 0 }),
            style({ transform: 'translateY(-20px)', offset: 0.5 }),
            style({ transform: 'translateY(0)', offset: 1 }),
          ]),
        ),
      ]),
    ]),
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(30px)' }),
        animate(
          '0.6s ease-out',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),
    ]),

    trigger('buttonPulse', [
      transition(':enter', [
        style({ transform: 'scale(0.8)', opacity: 0 }),
        animate(
          '0.5s 0.5s ease-out',
          style({ transform: 'scale(1)', opacity: 1 }),
        ),
      ]),
    ]),
  ],
})
export class UnauthorizedComponent {
  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
  ) {
    const urlObj = new URL(window.location.href);
    const token = urlObj.searchParams.get('token');

    console.log(token, 'Author Token');
  }

  goBack(): void {
    const role = localStorage.getItem('userRole');
    const dashboardMap: Record<string, string> = {
      student: 'dashboard/user',
      teacher: 'dashboard/teacher',
      csqadmin: 'dashboard/csq-admin',
      csquser: 'dashboard/csq-user',
      superadmin: 'dashboard/super-admin',
    };
    const path = role ? dashboardMap[role.toLowerCase()] : null;
    this.router.navigate([path || 'auth/login']);
  }
}
